/**
 * Safe-access helpers to guard against reading properties of undefined/null.
 * Centralizes the pattern so components and services stay clean and consistent.
 */
export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

/**
 * Returns the object only when it is a non-null object, otherwise an empty object.
 * Useful for safe destructuring: `const { firstName } = ensureObject(source);`
 */
export function ensureObject<T extends object>(value: T | null | undefined): Partial<T> {
  return isDefined(value) && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

/**
 * Returns the array when defined, otherwise an empty array to keep iterations safe.
 */
export function ensureArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) ? value : [];
}
